import { render, staticRenderFns } from "./outRecord.vue?vue&type=template&id=312f2b98&scoped=true&"
import script from "./outRecord.vue?vue&type=script&lang=js&"
export * from "./outRecord.vue?vue&type=script&lang=js&"
import style0 from "./outRecord.vue?vue&type=style&index=0&id=312f2b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f2b98",
  null
  
)

export default component.exports